export enum ChartLegendAlignment {
    start,
    center,
    end
}